import AnyField from './AnyField.js';
import ArrayField from './ArrayField.js';
import BaseField from './BaseField.js';
import BooleanField from './BooleanField.js';
import ConstField from './ConstField.js';
import DateField from './DateField.js';
import EnumField from './EnumField.js';
import MessageField from './MessageField.js';
import NumberField from './NumberField.js';
import OneOfField from './OneOfField.js';
import RecordField from './RecordField.js';
import StringField from './StringField.js';
export default (def) => {
    if (def instanceof BaseField) {
        return def;
    }
    else {
        switch (def.type) {
            case 'any':
                return new AnyField(def);
            case 'boolean':
                return new BooleanField(def);
            case 'string':
                return new StringField(def);
            case 'date':
                return new DateField(def);
            case 'number':
                return new NumberField(def);
            case 'array':
                return new ArrayField(def);
            case 'record':
                return new RecordField(def);
            case 'oneOf':
                return new OneOfField(def);
            case 'message':
                return new MessageField(def);
            case 'const':
                return new ConstField(def);
            case 'enum':
                return new EnumField(def);
            default:
                throw new Error(`Invalid field type ${def.type}`);
        }
    }
};
//# sourceMappingURL=createField.js.map